import { TextField } from "@mui/material";
import { styled } from '@mui/material/styles';

export const InputTextField = styled(TextField)({
    marginTop: "10px",
    marginBottom: "10px",
});